import { api } from "./index";

export interface GarantDeal {
    id: number;
    id_link: number | null;
    user_id: number;
    sum: number;
    total: number;
    desc: string;
    additional_desc: string;
    stat_time: number;
    confirm_time: number;
    tracking_time: number;
    appeal_time: number;
    transfer_back_time: number;
    currency: number;
    tracking: string;
    appeal: string | null;
    status: number;
    user?: {
        id: number;
        name: string;
        surname: string;
        ref_link?: string;
    };
}

export interface GarantListResponse {
    success: boolean;
    data: {
        data: GarantDeal[];
        current_page: number;
        last_page: number;
        per_page: number;
        total: number;
    };
}

export const garantsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getAdminGarants: builder.query<
            GarantListResponse,
            {
                status?: number | number[];
                currency?: number;
                direction?: "incoming" | "outgoing";
                user_id?: number;
                page?: number;
            } | void
        >({
            query: (params) => {
                if (!params) {
                    return "/admin/garants";
                }
                return {
                    url: "/admin/garants",
                    params,
                };
            },
            providesTags: (result) => [
                ...(result?.data?.data?.map((item) => ({
                    type: "AdminGarants" as const,
                    id: item.id,
                })) ?? []),
                { type: "AdminGarants" as const, id: "LIST" },
            ],
        }),
        resolveAppealRefund: builder.mutation<
            { success: boolean; message: string },
            number
        >({
            query: (id) => ({
                url: `/admin/garants/${id}/resolve-refund`,
                method: "POST",
            }),
            invalidatesTags: (_result, _error, id) => [
                { type: "AdminGarants" as const, id },
                { type: "AdminGarants" as const, id: "LIST" },
            ],
        }),
        resolveAppealConfirm: builder.mutation<
            { success: boolean; message: string },
            number
        >({
            query: (id) => ({
                url: `/admin/garants/${id}/resolve-confirm`,
                method: "POST",
            }),
            invalidatesTags: (_result, _error, id) => [
                { type: "AdminGarants" as const, id },
                { type: "AdminGarants" as const, id: "LIST" },
            ],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetAdminGarantsQuery,
    useResolveAppealRefundMutation,
    useResolveAppealConfirmMutation,
} = garantsApi;

